import { initReactI18next } from 'react-i18next';
import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './lang/en';
import es from './lang/es';
var resources = {
    en: en,
    es: es
};
var i18n = createInstance({
    fallbackLng: 'en', // use en if detected lng is not available
    returnEmptyString: false, // allow an empty value to count as invalid
    interpolation: {
        escapeValue: false // react already safe from xss
    },
    resources: resources
});
i18n.use(LanguageDetector).use(initReactI18next).init();
export default i18n;
//# sourceMappingURL=i18n.js.map